import React, { useEffect } from 'react'
import { connect } from 'react-redux'
import { reduxForm } from 'redux-form'
import { ToastContainer } from 'react-toastify'
import { INTERVALO_CORTO } from '../../../../config/settings'
import { actualizarDatosControlDeRebajas } from '../../actions/calidad'
import DatePicker from '../../../LaridaeApp/datepicker/container/DatePicker'
import { FORM_CONTROL_DE_REBAJAS } from '../../../../config/forms'
import ControlDeRebajasView from '../../components/calidad/ControlDeRebajasView'

function ControlDeRebajas (props) {
  const { actualizarDatosControlDeRebajas } = props

  useEffect(() => {
    actualizarDatosControlDeRebajas(new Date(), new Date())
  }, [actualizarDatosControlDeRebajas])

  const actualizarFechas = (fechaD, fechaH) => {
    actualizarDatosControlDeRebajas(fechaD, fechaH)
  }

  return (
    <>
      <ToastContainer autoClose={INTERVALO_CORTO} />
      <div className='container-entre-fechas'>
        <DatePicker
          selectRange
          locale='es'
          disabledFuture
          onDateChange={actualizarFechas}
          titulo='Seleccione las fechas'
          value='fechas'
        />
      </div>
      <ControlDeRebajasView />
    </>
  )
}

const mapActionsToProps = {
  actualizarDatosControlDeRebajas
}

const withReduxForm = reduxForm({
  form: FORM_CONTROL_DE_REBAJAS
})

const withRedux = connect(null, mapActionsToProps)
export default withRedux(withReduxForm(ControlDeRebajas))
